'use client';

import { useState } from 'react';
import Link from 'next/link';
import type { Route } from 'next';
import { usePathname } from 'next/navigation';

import { marketingNavAuthLinks, marketingV2NavLinks } from '@/config/marketing';

const DATA_W_ID = 'ceb98bd8-55d3-7a0f-619c-cc735890af3c';

export function WebflowMarketingNav() {
  const pathname = usePathname();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div
      data-animation="default"
      className="navbar1_component w-nav"
      data-easing2="ease"
      data-easing="ease"
      data-collapse="medium"
      data-w-id={DATA_W_ID}
      role="banner"
      data-duration="400"
    >
      <div className={`navbar1_container${isMobileMenuOpen ? ' mobile-expanded' : ''}`}>
        <div className="navbar1_top">
          <Link href="/" className="navbar1_logo-link w-nav-brand" aria-current="page">
            <img loading="lazy" src="/webflow-v2/images/logo.webp" alt="OutThere" className="navbar1_logo dark:hidden" />
            <img loading="lazy" src="/assets/brand/Outhere_logo_black.png" alt="OutThere" className="navbar1_logo hidden dark:block" />
          </Link>
          <nav role="navigation" className="navbar1_menu is-page-height-tablet w-nav-menu">
            <div className="navbar1_menu-links">
              {marketingV2NavLinks.slice(0, 4).map(link => (
                <Link
                  key={link.href}
                  href={link.href as Route}
                  className={`navbar1_link w-nav-link${pathname === link.href ? ' w--current' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="navbar1_menu-buttons">
              <Link href="/auth/signup" className="button is-secondary is-small w-button">
                Create account
              </Link>
              <Link href={marketingNavAuthLinks[0].href as Route} className="button is-small w-button">
                Sign In
              </Link>
            </div>
          </nav>
          <div 
            className={`navbar1_menu-button w-nav-button${isMobileMenuOpen ? ' w--open' : ''}`}
            aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <div className="menu-icon1">
              <div className="menu-icon1_line-top" />
              <div className="menu-icon1_line-middle">
                <div className="menu-icon1_line-middle-inner" />
              </div>
              <div className="menu-icon1_line-bottom" />
            </div>
          </div>
        </div>

        {/* Mobile Accordion Menu */}
        <div className={`navbar1_mobile-accordion${isMobileMenuOpen ? ' is-open' : ''}`}>
          <div className="mobile-accordion-content">
            <div className="mobile-accordion-links">
              {marketingV2NavLinks.slice(0, 4).map(link => (
                <Link
                  key={link.href}
                  href={link.href as Route}
                  className={`mobile-accordion-link${pathname === link.href ? ' active' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            
            <div className="mobile-accordion-buttons">
              <Link 
                href="/auth/signup" 
                className="button is-secondary is-small w-button"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Create account
              </Link>
              <Link 
                href={marketingNavAuthLinks[0].href as Route} 
                className="button is-small w-button"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
